var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownTheLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 30,
    rx: 4.5,
    fill: "#CD2A3F",
    stroke: "#CD2A3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05 19V12H12C14.25 12 15.78 13.42 15.78 15.5C15.78 17.58 14.25 19 12 19H9.05ZM10.05 18.13H11.94C13.67 18.13 14.78 17.07 14.78 15.5C14.78 13.93 13.67 12.87 11.94 12.87H10.05V18.13ZM17.4117 19V12H18.4117V18.13H22.2017V19H17.4117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTheLineIcon);
export default __webpack_public_path__ + "static/media/downTheLineIcon.7e85468ce58795fa2d6a893f69ef9a77.svg";
export { ForwardRef as ReactComponent };